exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-166b593c]::-webkit-scrollbar {\n  width: 4px;\n}\n.box[data-v-166b593c]::-webkit-scrollbar-thumb {\n  background-color: transparent;\n  outline: 1px solid white;\n  border-radius: 0.42rem !important;\n}\n.box[data-v-166b593c]::-webkit-scrollbar-thumb {\n  background-color: #e4e6ef;\n}\n", ""]);

// exports
